import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../styles/fonts';

export default createUseStyles(
  {
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: 20,
      gap: 20,
      background: 'var(--x-bg-1)',
      border: '2px solid var(--x-border-1)',
      borderRadius: 8,
      color: 'var(--x-text-color-1)',
    },
    name: {
      fontSize: 18,
      lineHeight: '21px',
      marginBottom: 5,
      fontWeight: FontWeight.Bold,
    },
    size: {
      fontSize: 14,
      lineHeight: '16px',
    },
  },
  { name: 'File' },
);
